import { createClient } from '@supabase/supabase-js';

// Using the specific credentials provided for this project environment
// Hardcoded to ensure connection works in the preview environment
const supabaseUrl = 'https://roizwoamoalengwseqwn.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJvaXp3b2Ftb2FsZW5nd3NlcXduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3NTM2NjAsImV4cCI6MjA3OTMyOTY2MH0.X9PJaUTlZmqq5UlMerfZliKWXc75pIGYruYATVFPYWY';

if (!supabaseUrl || !supabaseAnonKey || supabaseUrl === 'https://your-project.supabase.co') {
  console.error('Supabase credentials missing or invalid. Please check src/config/supabase.js');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Database Tables Schema
export const TABLES = {
  USERS: 'users',
  BREWERIES: 'breweries',
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  ORDERS: 'orders',
  ORDER_ITEMS: 'order_items',
  REVIEWS: 'reviews',
  BLOG_POSTS: 'blog_posts',
  BLOG_CATEGORIES: 'blog_categories',
  PLANS: 'plans',
  SUBSCRIPTIONS: 'subscriptions',
  PAYMENTS: 'payments',
  COUPONS: 'coupons',
  FAVORITES: 'favorites',
  NOTIFICATIONS: 'notifications'
};

// User Roles
export const USER_ROLES = {
  CUSTOMER: 'customer',
  BREWERY_OWNER: 'brewery_owner',
  ADMIN: 'admin'
};

// Order Status
export const ORDER_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PREPARING: 'preparing',
  READY: 'ready',
  OUT_FOR_DELIVERY: 'out_for_delivery',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled'
};

// Subscription Plans
export const PLAN_TYPES = {
  FREE: 'free',
  PRO: 'pro'
};